<template>
  <v-app>
    <page-header>
      <span slot="header-title">{{$t('_ACTIVITY.TITLE')}}</span>
    </page-header>
    <left-menu />
    <div class="main-content right-page-content" id="list-booking-transaction">
      <loading :active.sync="isLoading" :is-full-page="false"></loading>
      <div class="content-wrapper">
        <div class="card-item">
          <div class="card-item-content small-padding">
            <v-row align="center">
              <v-col cols="2.5">
                  <label class="label-input">{{$t("_ACTIVITY.ACTION_DATE")}}</label>
                  <div class="d-flex justify-content-between">
                    <date-range
                      valueFormat="YYYY-MM-DD"
                      :startDate.sync="paging.from"
                      :endDate.sync="paging.to"
                    />
                  </div>
              </v-col>
              <v-col cols="2.5">
                <label class="label-input">{{$t("_ACTIVITY.ACTION_BY")}}</label>
                <select-text
                  :items="listUserName"
                  :id.sync="selectedUserNameId"
                  @change="changeUserName"
                />
              </v-col>
               <v-col cols="2.5">
                <label class="label-input">{{$t("ACTION")}}</label>
                <select-text
                  :items="listAction"
                  :id.sync="selectedActionId"
                   @change="changeAction"
                />
              </v-col>
              <v-col cols="2.5" class="text-right">
                <button @click="getAll(true)" class="main-btn btn-pmirary mt-7">{{$t('_BOOKING.SEARCH')}}</button>
              </v-col>
            </v-row>
          </div>
          <v-data-table
            :headers="headers"
            :items="data"
            :items-per-page="20"
            disable-sort
            hide-default-footer
            item-key="id"
            class="main-table"
          >
            <template slot="no-data">
              <span>{{$t("HAS_NO_DATA")}}</span>
            </template>
            <!-- <template v-slot:item.applyDate="{ item }">
              <span class="d-block">{{item.applyDate}}</span>
            </template> -->
            <template v-slot:item.action="{ item }">
              <span class="d-block">{{$t("_ACTIVITY."+item.action)}}</span>
            </template>
            <template v-slot:item.dataBefore="{ item }">
                <span style="text-align:left"><div v-html="parseLogData(item.dataBefore)"></div></span>
            </template>
            <template v-slot:item.dataAfter="{ item }">
                <span style="text-align:left"><div v-html="parseLogData(item.dataAfter)"></div></span>
            </template>
             <template v-slot:item.createdBy="{ item }">
                <p class="mb-0" v-if="item.fullname">{{item.fullname}}</p>
                <p class="mb-0" v-if="item.createdBy">({{item.createdBy}})</p>
              </template>
          </v-data-table>
          <paging v-if="paging && paging.total" :paging.sync="paging" @changePage="changePage">
            <span slot="totalItems">{{$t("TOTAL")}}: {{paging.total}} {{$t("_ACTIVITY.DOCUMENT")}}</span>
          </paging>
        </div>
      </div>
    </div>
  </v-app>
</template>

<style lang="scss" scoped>
#list-booking-transaction {
  .truncate-text {
    // white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  // .main-table{
  // white-space: nowrap;
  // }
}
.col-12 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}
</style>

<script>
import PageHeader from "@/components/Utils/Header.vue";
import LeftMenu from "@/components/Utils/LeftMenu.vue";
import Input from "@/components/Utils/Input.vue";
import Select from "@/components/Utils/Select.vue";
import DatePicker from "@/components/Utils/DatePicker.vue";
import Paging from "@/components/Utils/Paging.vue";
import DateRange from "@/components/Utils/DateRange.vue";
import { REGEX_NUMBER } from "@/_helpers/constant.js";
import { LIMIT_AND_OFFSET } from "@/_helpers/config.js";
import {
  _alert,
  _formatDateTime,
  _formatCurrency
} from "@/_helpers/function.js";
import { service } from "@/_services/ActivityDiary/activityDiary.service.js";
import moment from "moment";
import FileSaver from "file-saver";

export default {
  components: {
    "page-header": PageHeader,
    "left-menu": LeftMenu,
    "input-text": Input,
    "select-text": Select,
    "date-picker": DatePicker,
    "date-range": DateRange,
    paging: Paging
  },
  data() {
    return {
      isLoading: false,
      headers: [
        {
          text: this.$t("_ACTIVITY.ACTION_DATE"),
          align: "left",
          value: "createdDate",
          width: "10%"
        },
        {
          text: this.$t("_ACTIVITY.DATABEFORE"),
          align: "left",
          value: "dataBefore",
          width: "30%"
        },
        {
          text: this.$t("_ACTIVITY.DATAAFTER"),
          align: "left",
          value: "dataAfter",
          width: "30%"
        },
        {
          text: this.$t("_ACTIVITY.ACTION"),
          align: "left",
          value: "action",
          width: "10%"
        },
        {
          text: this.$t("_ACTIVITY.IPADDRESS"),
          align: "left",
          value: "ip",
          width: "10%"
        },
        {
          text: this.$t("_ACTIVITY.ACTION_BY"),
          align: "left",
          value: "createdBy",
          width: "10%"
        }
      ],
      data: [],
      selectedUserNameId: 0,
      selectedActionId: 0,
      selectedRoomId: 0,
      selectedRoomPlanId: 0,
      listUserName: [],
      listAction: [
        {
          id: 0,
          key: null,
          value: this.$t("_ACTIVITY.ALLSELECT")
        },
        {
          id: 1,
          key: 'HOTEL_LOGIN',
          value: this.$t("_ACTIVITY.HOTEL_LOGIN")
        },
        {
          id: 2,
          key: 'HOTEL_CANCEL_BOOKING',
          value: this.$t("_ACTIVITY.HOTEL_CANCEL_BOOKING")
        },
        {
          id: 3,
          key: 'HOTEL_UPDATE_PAYMENT_BOOKING',
          value: this.$t("_ACTIVITY.HOTEL_UPDATE_PAYMENT_BOOKING")
        },
        {
          id: 4,
          key: 'HOTEL_REQUEST_BOOKING',
          value: this.$t("_ACTIVITY.HOTEL_REQUEST_BOOKING")
        },
        {
          id: 5,
          key: 'HOTEL_ROOM_PLAN_CREATE',
          value: this.$t("_ACTIVITY.HOTEL_ROOM_PLAN_CREATE")
        },
        {
          id: 6,
          key: 'HOTEL_ROOM_PLAN_UPDATE',
          value: this.$t("_ACTIVITY.HOTEL_ROOM_PLAN_UPDATE")
        },
        {
          id: 7,
          key: 'HOTEL_ROOM_PLAN_COPY',
          value: this.$t("_ACTIVITY.HOTEL_ROOM_PLAN_COPY")
        },
        {
          id: 8,
          key: 'HOTEL_ROOM_PLAN_DELETE',
          value: this.$t("_ACTIVITY.HOTEL_ROOM_PLAN_DELETE")
        },
         {
          id: 9,
          key: 'HOTEL_PROMOTION_CREATE',
          value: this.$t("_ACTIVITY.HOTEL_PROMOTION_CREATE")
        },
        {
          id: 10,
          key: 'HOTEL_PROMOTION_UPDATE',
          value: this.$t("_ACTIVITY.HOTEL_PROMOTION_UPDATE")
        },
         {
          id: 11,
          key: 'HOTEL_PROMOTION_COPY',
          value: this.$t("_ACTIVITY.HOTEL_PROMOTION_COPY")
        },
         {
          id: 12,
          key: 'HOTEL_PROMOTION_DELETE',
          value: this.$t("_ACTIVITY.HOTEL_PROMOTION_DELETE")
        },
        {
          id: 13,
          key: 'HOTEL_PROFILE_UPDATE',
          value: this.$t("_ACTIVITY.HOTEL_PROFILE_UPDATE")
        },
        {
          id: 14,
          key: 'HOTEL_AVATAR_ADD',
          value: this.$t("_ACTIVITY.HOTEL_AVATAR_ADD")
        },
         {
          id: 15,
          key: 'HOTEL_AVATAR_REMOVE',
          value: this.$t("_ACTIVITY.HOTEL_AVATAR_REMOVE")
        },
        {
          id: 16,
          key: 'HOTEL_CHANGE_PASSWORD_PROFILE',
          value: this.$t("_ACTIVITY.HOTEL_CHANGE_PASSWORD_PROFILE")
        },
         {
          id: 17,
          key: 'HOTEL_USER_CREATE',
          value: this.$t("_ACTIVITY.HOTEL_USER_CREATE")
        },
         {
          id: 18,
          key: 'HOTEL_USER_UPDATE',
          value: this.$t("_ACTIVITY.HOTEL_USER_UPDATE")
        },
        {
          id: 19,
          key: 'HOTEL_USER_UPDATE_ROLE',
          value: this.$t("_ACTIVITY.HOTEL_USER_UPDATE_ROLE")
        },
        {
          id: 20,
          key: 'HOTEL_USER_DELETE',
          value: this.$t("_ACTIVITY.HOTEL_USER_DELETE")
        },
         {
          id: 21,
          key: 'HOTEL_GROUP_CREATE',
          value: this.$t("_ACTIVITY.HOTEL_GROUP_CREATE")
        },
          {
          id: 22,
          key: 'HOTEL_GROUP_UPDATE',
          value: this.$t("_ACTIVITY.HOTEL_GROUP_UPDATE")
        },
        {
          id: 23,
          key: 'HOTEL_GROUP_UPDATE_ROLE',
          value: this.$t("_ACTIVITY.HOTEL_GROUP_UPDATE_ROLE")
        },
        {
          id: 24,
          key: 'HOTEL_GROUP_DELETE',
          value: this.$t("_ACTIVITY.HOTEL_GROUP_DELETE")
        },
        {
          id: 25,
          key: 'HOTEL_CONTRACT_UPDATE',
          value: this.$t("_ACTIVITY.HOTEL_CONTRACT_UPDATE")
        },
        {
          id: 26,
          key: 'HOTEL_INFO_UPDATE',
          value: this.$t("_ACTIVITY.HOTEL_INFO_UPDATE")
        },
        {
          id: 27,
          key: 'HOTEL_UPDATE_AMENITIES',
          value: this.$t("_ACTIVITY.HOTEL_UPDATE_AMENITIES")
        },
        {
          id: 28,
          key: 'HOTEL_UPDATE_IMAGES',
          value: this.$t("_ACTIVITY.HOTEL_UPDATE_IMAGES")
        },
        {
          id: 29,
          key: 'HOTEL_DELETE_IMAGES',
          value: this.$t("_ACTIVITY.HOTEL_DELETE_IMAGES")
        },
        {
          id: 30,
          key: 'HOTEL_AREA_CREATED',
          value: this.$t("_ACTIVITY.HOTEL_AREA_CREATED")
        },
        {
          id: 31,
          key: 'HOTEL_AREA_UPDATED',
          value: this.$t("_ACTIVITY.HOTEL_AREA_UPDATED")
        },
        {
          id: 32,
          key: 'HOTEL_AREA_DELETED',
          value: this.$t("_ACTIVITY.HOTEL_AREA_DELETED")
        },
        {
          id: 33,
          key: 'HOTEL_CHAIN_CREATED',
          value: this.$t("_ACTIVITY.HOTEL_CHAIN_CREATED")
        },
        {
          id: 34,
          key: 'HOTEL_CHAIN_UPDATED',
          value: this.$t("_ACTIVITY.HOTEL_CHAIN_UPDATED")
        },
        {
          id: 35,
          key: 'HOTEL_ROOM_CREATED',
          value: this.$t("_ACTIVITY.HOTEL_ROOM_CREATED")
        },
        {
          id: 36,
          key: 'HOTEL_ROOM_UPDATED',
          value: this.$t("_ACTIVITY.HOTEL_ROOM_UPDATED")
        },
        {
          id: 37,
          key: 'HOTEL_ROOM_COPY',
          value: this.$t("_ACTIVITY.HOTEL_ROOM_COPY")
        },
        {
          id: 38,
          key: 'HOTEL_ROOM_DELETED',
          value: this.$t("_ACTIVITY.HOTEL_ROOM_DELETED")
        },
        {
          id: 39,
          key: 'HOTEL_ROOM_AMENITY',
          value: this.$t("_ACTIVITY.HOTEL_ROOM_AMENITY")
        },
        {
          id: 40,
          key: 'HOTEL_ROOM_ADD_IMAGES',
          value: this.$t("_ACTIVITY.HOTEL_ROOM_ADD_IMAGES")
        },
        {
          id: 41,
          key: 'HOTEL_ROOM_DELETE_IMAGES',
          value: this.$t("_ACTIVITY.HOTEL_ROOM_DELETE_IMAGES")
        },
        {
          id: 42,
          key: 'HOTEL_UPDATE_HOTEL_SETTING_INFO',
          value: this.$t("_ACTIVITY.HOTEL_UPDATE_HOTEL_SETTING_INFO")
        },
        {
          id: 43,
          key: 'HOTEL_PAYMENT_POLICY_CREATED',
          value: this.$t("_ACTIVITY.HOTEL_PAYMENT_POLICY_CREATED")
        },
        {
          id: 44,
          key: 'HOTEL_PAYMENT_POLICY_UPDATED',
          value: this.$t("_ACTIVITY.HOTEL_PAYMENT_POLICY_UPDATED")
        },
        {
          id: 45,
          key: 'HOTEL_PAYMENT_POLICY_DELETED',
          value: this.$t("_ACTIVITY.HOTEL_PAYMENT_POLICY_DELETED")
        },
        {
          id: 46,
          key: 'HOTEL_CANCEL_POLICY_CREATED',
          value: this.$t("_ACTIVITY.HOTEL_CANCEL_POLICY_CREATED")
        },
        {
          id: 47,
          key: 'HOTEL_CANCEL_POLICY_UPDATED',
          value: this.$t("_ACTIVITY.HOTEL_CANCEL_POLICY_UPDATED")
        },
        {
          id: 48,
          key: 'HOTEL_CANCEL_POLICY_DELETED',
          value: this.$t("_ACTIVITY.HOTEL_CANCEL_POLICY_DELETED")
        },
        {
          id: 49,
          key: 'HOTEL_SETTING_PAYMENT_GATE',
          value: this.$t("_ACTIVITY.HOTEL_SETTING_PAYMENT_GATE")
        },
        {
          id: 50,
          key: 'HOTEL_ADD_IMAGES_SLIDE',
          value: this.$t("_ACTIVITY.HOTEL_ADD_IMAGES_SLIDE")
        },
        {
          id: 51,
          key: 'HOTEL_DELETE_IMAGES_SLIDE',
          value: this.$t("_ACTIVITY.HOTEL_DELETE_IMAGES_SLIDE")
        },
        {
          id: 52,
          key: 'HOTEL_REMOVE_CONNECT_AGENT',
          value: this.$t("_ACTIVITY.HOTEL_REMOVE_CONNECT_AGENT")
        },
        {
          id: 53,
          key: 'HOTEL_UPDATE_LEVEL_AGENT',
          value: this.$t("_ACTIVITY.HOTEL_UPDATE_LEVEL_AGENT")
        },
        {
          id: 54,
          key: 'HOTEL_RETURN_CONNECT_AGENT',
          value: this.$t("_ACTIVITY.HOTEL_RETURN_CONNECT_AGENT")
        },
      ],
      listRoom: [],
      listRoomPlan: [
        {
          id: 0,
          key: null,
          value: this.$t("_ACTIVITY.ALLSELECT")
        }
      ],
      paging: {
        total: 0,
        userName: null,
        action: null,
        from: null,
        to: null,
        limit: 20,
        offset: 0,
      }
    };
  },
  computed: {
    REGEX_NUMBER() {
      return REGEX_NUMBER;
    }
  },
  mounted() {
    this.initialize();
  },
  created() {
    // this.initialize();
  },
  methods: {
    formatDateTime(value, inputFormat, outputFormat) {
      return _formatDateTime(value, inputFormat, outputFormat);
    },
    formatCurrency(amount) {
      return _formatCurrency(amount);
    },
    // Run when start
    initialize() {
      // Call service
      this.getAll();
      this.getUserName();
      this.changeUserName();
    },
    // Change page
    changePage(paging) {
      this.paging = paging;
      this.getAll();
    },
    changeUserName() {
      const selectedItem = this.listUserName.find(
        item => item.id === this.selectedUserNameId
      );
      this.paging.userName = selectedItem ? selectedItem.key : null;
    },
    changeAction() {
      const selectedItem = this.listAction.find(
        item => item.id === this.selectedActionId
      );
      this.paging.action = selectedItem ? selectedItem.key : null;
    },
    getUserName() {
      this.listUserName = [
        {
          id: 0,
          key: null,
          value: this.$t("_ACTIVITY.ALLSELECT")
        }
      ];
      service.getUserName().then(res => {
        if (res.responseCode === 0) {
          res.data.forEach((element, index)=> {
            this.listUserName.push({
              id: index + 1,
              key: element.username,
              value: element.fullname,
            });
          });
        } else {
          _alert(res, this.$t(res.data), false);
        }
      })
      .finally(() => (this.isLoading = false));
    },
    convertAction(actionCode) {
        const logType = this.logTypes.filter(item => item.id == actionCode);
        if (logType && logType[0]) {
            return logType[0].label;
        }
        return actionCode;
    },
    getKeyWordLog(key, value) {
        let keyString = '';
        // eslint-disable-next-line no-restricted-globals
        if (!isNaN(key)) {
            keyString = key;
        } else {
            keyString = this.$t(`HOTEL_LOG_${key}`);
        }
        return `<strong>${keyString}</strong> : ${value}`;
    },
    parseLogData(logJson) {
        try {
            if (typeof logJson !== 'undefined' && logJson !== null && logJson !== '') {
                const logData = JSON.parse(logJson);
                // console.log(logJson);
                const outPut = this.parseChildData(logData, true);

                return outPut;
            }
            return logJson;
        } catch (e) {
            // console.log(e.getMessage);
            return null;
        }
    },
    parseChildData(data, first = false) {
        let logStringOut = '';
        if (!first) {
            logStringOut += '<br/>';
            logStringOut += "<div class='ml-4'>";
        }
        for (const prop in data) {
            if (typeof data[prop] === 'object') {
                logStringOut += this.getKeyWordLog(prop, this.parseChildData(data[prop]));
            } else {
                logStringOut += `${this.getKeyWordLog(prop, data[prop])}<br/>`;
            }
        }
        if (!first) {
            logStringOut += '</div>';
        }
        return logStringOut;
    },
    // Get all booking
    getAll(isSearching) {
      const locale = localStorage.getItem("systemLanguage") || "vi";
      if (isSearching) this.paging.offset = 0;
      this.isLoading = true;
      const body = {
        userName: this.paging.userName,
        action: this.paging.action,
        from: this.paging.from,
        to: this.paging.to,
        size: this.paging.limit,
        page: this.paging.offset%this.paging.limit > 0 ? this.paging.offset/this.paging.limit + 1 : this.paging.offset/this.paging.limit,
      }
      service
        .getAllActivity(body)
        .then(res => {
          if (res.responseCode === 0) {
            this.paging.total = res.total;
            this.data = res.data.map(item => {
              // Mapping bookedDay
              let createdDate = moment(item.createdDate);
              item.createdDate = createdDate.format("DD/MM/YYYY HH:mm:ss");

              // console.log(item);
              return item;
            });
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
  }
};
</script>